import { render, staticRenderFns } from "./FindQuestion.vue?vue&type=template&id=36baff14&scoped=true&"
import script from "./FindQuestion.vue?vue&type=script&lang=js&"
export * from "./FindQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FindQuestion.vue?vue&type=style&index=0&lang=css&"
import style1 from "../../css/newCreateProject.css?vue&type=style&index=1&id=36baff14&scoped=true&lang=css&"
import style2 from "./FindQuestion.vue?vue&type=style&index=2&id=36baff14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36baff14",
  null
  
)

export default component.exports